import { useRef, useState } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Volume2, VolumeX } from "lucide-react";
import { useI18n } from "@/lib/i18n";
import { useSite } from "@/lib/site";
import { mediaUrl } from "@/lib/api";

export const VideoSection = () => {
  const { t } = useI18n();
  const { data } = useSite();
  const s = data?.settings || {};
  const ref = useRef(null);
  const vidRef = useRef(null);
  const [muted, setMuted] = useState(true);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const scale = useTransform(scrollYProgress, [0, 1], [1.1, 1]);

  if (!s.promo_video_path) return null;

  const toggleMute = () => {
    if (vidRef.current) {
      vidRef.current.muted = !vidRef.current.muted;
      setMuted(vidRef.current.muted);
    }
  };

  return (
    <section ref={ref} className="py-24 sm:py-32" data-testid="video-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="flex items-end justify-between gap-6 mb-10">
          <div>
            <p className="font-mono text-[11px] tracking-[0.3em] text-gold mb-4">{t("video.eyebrow")}</p>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-bone leading-[0.95]">
              {t("video.title")}
            </h2>
          </div>
          <button
            data-testid="video-mute-toggle"
            onClick={toggleMute}
            title={muted ? "Activar sonido" : "Silenciar"}
            className="shrink-0 h-12 w-12 rounded-full border border-gold/40 text-gold flex items-center justify-center hover:bg-gold hover:text-ink transition-colors"
          >
            {muted ? <VolumeX size={18} /> : <Volume2 size={18} />}
          </button>
        </div>

        <motion.div
          style={{ scale }}
          className="relative border border-gold/20 overflow-hidden bg-panel"
          data-testid="promo-video-frame"
        >
          <video
            ref={vidRef}
            autoPlay
            muted
            loop
            playsInline
            preload="metadata"
            poster={s.promo_poster_path ? mediaUrl(s.promo_poster_path) : undefined}
            className="w-full aspect-video object-cover"
          >
            <source src={mediaUrl(s.promo_video_path)} type="video/mp4" />
          </video>
          <div className="absolute inset-0 pointer-events-none bg-gradient-to-t from-ink/45 via-transparent to-transparent" />
          <span className="absolute -top-px left-1/2 -translate-x-1/2 h-px w-32 bg-gold" />
          <span className="absolute -bottom-px left-1/2 -translate-x-1/2 h-px w-32 bg-gold" />
        </motion.div>
      </div>
    </section>
  );
};

export default VideoSection;
